export default {
  "base": "grid grid-cols-1 sm:grid-cols-2 gap-5 my-5 *:my-0"
}